import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RepitApiInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(request.url.match(/(invoice)+\/+(?:bap|repit)+\/+[0-9]/))
    {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/pdf'
        },withCredentials:true,responseType:'blob'
      });
    }else
    {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json'
        },withCredentials:true
      });
    }
    return next.handle(request);
  }
}
